// extracted by mini-css-extract-plugin
export default {"bookingStatus":"Style_bookingStatus__uWJ2g","badge":"Style_badge__gUQTG","content":"Style_content__4qfpY"};